import config from '@/Constants';
import {
  QueryDashParams,
  QueryDashResponse,
} from '@queryfilter/domain/interfaces';
import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';

async function fetchDash(
  dashId: string,
  params: QueryDashParams,
): Promise<QueryDashResponse> {
  const urlAux = config.DASHBOARD_MOCK ? config.DASHBOARD_MOCK_URL : '';

  let url = `${urlAux}dashboards/${dashId}`;

  if (params.filters) url += params.filters;

  const response = await AxiosHelper.get({ url });
  const data: QueryDashResponse = response.body;
  return data;
}

export default fetchDash;
